import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ConfirmationService, MenuItem, Message, MessageService } from 'primeng/api';
import { OverlayPanel } from 'primeng/overlaypanel';
import { AdministracionService } from 'src/app/administracion/administracion.service';
import { BreadcrumbService } from 'src/app/app.breadcrumb.service';
import { ContactosService } from 'src/app/contactos/contactos.service';
import { FAZILService, User, UserService } from 'src/app/core';
import { ResultData, UIService } from 'src/app/core/services/ui.service';
import { EmissionPoint } from 'src/app/modelo/EmissionPoint';
import { Establishment } from 'src/app/modelo/Establishment';
import { Invoice } from 'src/app/modelo/Invoice';
import { InvoiceDetail } from 'src/app/modelo/InvoiceDetail';
import { Product } from 'src/app/modelo/Product';
import { Subject } from 'src/app/modelo/Subject';
import { SubjectCustomer } from 'src/app/modelo/SubjectCustomer';
import { ComprobantesService } from 'src/app/services/comprobantes.service';
import { DataService } from 'src/app/services/data.service';
import { ServiciosService } from 'src/app/servicios/servicios.service';
import { precisionRound, validateDni, validateDNIPattern, validateEmail, validateRUC } from 'src/app/shared/helpers';
import { environment } from 'src/environments/environment';
import { FacturasService } from '../facturas.service';
import { PaymentMethod } from 'src/app/modelo/PaymentMethod';
import { EstablecimientosService } from 'src/app/perfil/establecimientos/establecimientos.service';

import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

import { COMMA, ENTER, ESCAPE, SPACE, TAB } from '@angular/cdk/keycodes';
import { FormControl } from '@angular/forms';
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { MatChipInput, MatChipInputEvent, MatChipList } from '@angular/material/chips';
import { MatAutocomplete, MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';

import {InputMaskModule} from 'primeng/inputmask';
import { VeronicaApiSubErrorData } from 'src/app/modelo/VeronicaAPIErrorData';
import { IVA } from 'src/app/modelo/SRIData';
import { PageOptions } from 'src/app/core/models/pagination';
import { SubjectCustomerOutput } from 'src/app/core/models/contacto.model';

@Component({
    selector: 'app-notadecredito-popup',
    templateUrl: './notadecredito-popup.component.html',
    styleUrls: ['./notadecredito-popup.component.scss']
})
export class NotadecreditoPopupComponent implements OnInit {

    //Variables de configuración/mensajes
    appConfig = environment.settings;

    errors: Object = {};
    msgs: Message[] = [];

    //Variables con objeto de edición
    currentUser: User;
    factura: Invoice = new Invoice();
    details: InvoiceDetail[] = [];

    //Variables para contactos
    subjectCustomers: SubjectCustomer[] = [];
    subjectCustomersFiltered: SubjectCustomer[] = [];
    subjectCustomer: SubjectCustomer = new SubjectCustomer();
    mostrarPopupSubjectCustomers: boolean = false;
    mostrarEditorSubject: boolean = false;
    subject: Subject = new Subject();
    subjectCode: string;
    subjectCodeValid: boolean = false;
    emailValid: boolean = false;
    searching = false;

    //Variables para productos
    products: Product[] = [];
    productsFiltered: Product[] = [];
    productTypes: any[] = [];
    productType: any;
    product: Product = new Product();
    productSelected: Product = new Product();
    mostrarPopupProducts: boolean = false;
    mostrarEditorProduct: boolean = false;
    ivaValor: number = this.appConfig.app.iva.factor / 100;
    iva12: boolean = true;

    //Variables para establecimientos
    establishments: Establishment[] = [];
    establishment: Establishment = new Establishment();
    emissionPointSelected: EmissionPoint = new EmissionPoint();

    //Variables auxiliares
    isUnitDetail: boolean = true;
    exitenProductosSeleccionados: boolean = false;

    cargandoDataInit: boolean = false;
    procesando: boolean = false;
    processFilter = false;
    verificando: boolean = false;
    verificandoData: ResultData;
    resultData: ResultData;
    resultDataButtons: any[] = [];
    mostrarResultData: boolean = false;
    ui: UIService;

    paymentMethods: PaymentMethod[] = [];
    selectedPaymentMethod: PaymentMethod;

    //Help Section
    safeSrc: SafeResourceUrl;
    display: boolean;
    pageDescription: string;

    //Campos adicionales
    camposAdicionales: any[] = [];

    //Chips destinatarios
    separatorKeysCodes: number[] = [ENTER, COMMA, SPACE, TAB];
    destinatarioCtrl = new FormControl('');
    filtered: Observable<string[]>;
    destinatarios: string[] = [];
    destinatariosAll: string[] = [];
    @ViewChild('destinatarioInput') destinatarioInput: ElementRef<HTMLInputElement>;
    @ViewChild('auto') matAutocomplete: MatAutocomplete;

    //Catalgos para nota de credito
    tiposComprobantes: PaymentMethod[] = [];
    selectedTipoComprobante: PaymentMethod;
    filtrados: any[] = [];
    
    fechaActual: Date = new Date();
    
    //Implementación de control de porcentaje de iva en función de la fecha
    iva: IVA = new IVA();
    cambiarPorcentajesIVA: boolean = false;
    
    pageOptions: PageOptions = { page: 0, pageSize: 10, filter: '' };
    
    seRealizoBusquedaEspecifica:boolean = false;

    constructor(
        private router: Router,
        private route: ActivatedRoute,
        private userService: UserService,
        private fazilService: FAZILService,
        private uiService: UIService,
        private dataService: DataService,
        private confirmationService: ConfirmationService,
        private breadcrumbService: BreadcrumbService,
        private messageService: MessageService,
        private facturasService: FacturasService,
        private comprobantesService: ComprobantesService,
        private contactosService: ContactosService,
        private serviciosService: ServiciosService,
        private administracionService: AdministracionService,
        private establecimientosService: EstablecimientosService,
        private sanitizer: DomSanitizer,
    ) {
        this.ui = uiService;
        this.cargarDataConstructor();

        this.safeSrc = this.sanitizer.bypassSecurityTrustResourceUrl('https://www.facturafacilecuador.com/ayudas_docs/pdf/ayuda/ayuda_nueva_factura.pdf');
        this.pageDescription = 'En esta opción usted puede realizar la emisión de una nueva nota de crédito para un cliente.';
        
        this.iva = this.appConfig.app.iva;
    }
    
    ngOnInit(): void {
        this.userService.currentUser.subscribe(userData => {
            this.currentUser = userData;
            if (this.currentUser && this.currentUser.uuid) {
                if (this.currentUser.assistant.complete) {
                    this.cargarDataInit();
                } else {
                    this.fazilService.irAInicio(); //Mostrar el asistente
                }
            }
        });
    }

    cargarDataConstructor() {
        this.cargandoDataInit = true;
        this.route.data.subscribe((data) => {
            if (data['factura']) {//Editar factura normal
                this.factura = data['factura'];
            } else if (data['facturaExtendido']) {//Es una factura extendida
                this.factura = data['facturaExtendido'];
            }
        });
        this.breadcrumbService.setItems([
            { label: 'Nota de Crédito', routerLink: ['facturas/notasdecredito/notadecredito'] }
        ]);

        this.productTypes = this.appConfig.properties.productTypes;
    }

    async cargarDataInit() {

        //Cargar tiposComprobantes
        this.tiposComprobantes = await this.comprobantesService.getTiposComprobantesData();

        //Cargar datos de la factura
        //Cargar customer
        if (this.factura && this.factura.subjectCustomer) {
            this.subjectCustomer = this.factura.subjectCustomer;
            this.factura.subjectCustomer = new SubjectCustomer();
        }

        //Cargar details
        if (this.factura && this.factura.details && this.factura.details.length > 0) {
            this.details = this.factura.details ? this.factura.details : [];
            this.productsFiltered = this.ui.getProductsByDetails(this.details, this.products);
            this.isUnitDetail = this.ui.checkInvoiceSimpleComplex(this.details);
            this.generarFacturaSimpleComplex();
        }

        //Cargar método de pago
//        if (this.factura && this.factura.paymentMethod) {
//            let method: PaymentMethod = this.paymentMethods.find((item) => item.code == this.factura.paymentMethod);
//            this.selectedPaymentMethod = method ? method : new PaymentMethod();
//        }
        //Cargar método de pago
        if (this.factura && this.factura.notaCredito.tipoDocumentoModificacion) {
            let method: PaymentMethod = this.tiposComprobantes.find((item) => item.code == this.factura.notaCredito.tipoDocumentoModificacion);
            this.selectedTipoComprobante = method ? method : new PaymentMethod();
        }

        //Cargar emissionPoint y establishment
        if (this.factura && this.factura.emissionPoint && this.factura.emissionPoint.id) {
            let estab: Establishment = this.establishments.find((item) => item.id == this.factura.emissionPoint.establishmentId);
            if (estab && estab.id) {
                this.establishment = estab;
                if (this.establishment.emissionPoints && this.establishment.emissionPoints.length > 0) {
                    let point: EmissionPoint = this.establishment.emissionPoints.find((item) => item.id == this.factura.emissionPoint.id);
                    this.emissionPointSelected = point ? point : new EmissionPoint();
                }
            }
        }

        //Cargar emissionPoint si es nueva factura
        if (!this.factura || !this.factura.id) {
            let estab: Establishment = (this.establishments && this.establishments.length > 0) ? this.establishments[0] : new Establishment();
            this.emissionPointSelected = (estab && estab.emissionPoints && estab.emissionPoints.length > 0) ? estab.emissionPoints[0] : new EmissionPoint();
        }

        //Validar campos para reenvío POSTED
        if (this.factura && this.factura.internalStatus && this.factura.internalStatus == 'POSTED') {
            if (!this.formMainValid()) {
                this.ui.mostrarMensaje("warn", `${this.appConfig.ux.formIvalid}. No podrá emitir esta nota de crédito debido a que falta información importante no modificable. 
                Le recomendamos que realice una nueva nota de crédito.`);
            }
        }

        //Cargar campos adicionales de la organización
        this.camposAdicionales = []; //Encerar opciones.
        const campoAdicional = this.currentUser.organization.campoAdicional;
        const splits = campoAdicional && campoAdicional.length > 0 ? campoAdicional.split(",") : [];
        let index = 0;
        splits.forEach(campo => {
            this.camposAdicionales.push({ name: 'Campo' + index, type: 'text', value: null, label: campo })
            index++;
        });
        this.cargandoDataInit = false;
    }

    confirmarFacturar(event) {
        this.ui.limpiarMessages();
        if (this.currentUser.tieneCertificadoDigital) {
            //Ventana de confirmación
            let mensaje = this.appConfig.ux.confirmEnvioFacturaDesarrollo;
            if (this.currentUser.organization.ambientePro) {
                mensaje = this.appConfig.ux.confirmEnvioFacturaProduccion;
            }
            this.confirmationService.confirm({
                message: mensaje,
                accept: () => {
                    this.guardarFactura(event);
                },
            });
        } else {
            let header = "¡Suscríbase a " + this.appConfig.app.name + "!";
            let body = `Registre su certificado de firma electrónica llamando al ${environment.settings.app.contact.phone} o escribiendo a ${environment.settings.app.contact.email}.`;
            let type = "error";
            this.resultData = { header: header, body: body, type: type, subErrors: null };
            this.resultDataButtons = [];
            this.resultDataButtons.push(this.appConfig.ux.resultDataButtons.buttonOk);
            this.mostrarResultData = true;
        }
    }

    formMainValid() {
        let valido: boolean = true;
        if (!this.subjectCustomer
            || !this.subjectCustomer.customerCode
            || !(validateDni(this.subjectCustomer.customerCode)
                || validateRUC(this.subjectCustomer.customerCode))) {
            this.ui.mostrarMensaje("error", `${this.appConfig.validationMsgs.cirucCustomerInvalid}`);
            valido = false;
        } else if (!this.factura || !this.subjectCustomer || !this.details) {
            valido = false;
        } else if (this.factura && this.factura.direccion === '') {
            valido = false;
        } else if (this.factura && (!this.destinatarios || this.destinatarios.length == 0)) {
            valido = false;
        } 
        return valido;
    }

    async guardarFactura(event) {
        this.ui.limpiarMessages();

        if (!this.formMainValid()) {
            this.ui.mostrarMensaje("error", `${this.appConfig.ux.formIvalid}`);
        } else {
            this.procesando = true;
            this.subjectCustomer.customerPhoto = "";//remover foto
            //Establecer valores UX
            this.factura.details = this.details; //Los detalles de la factura
            this.factura.subjectCustomer = this.subjectCustomer;
            this.factura.emissionOn = this.factura.emissionOn ? this.factura.emissionOn : new Date();

            if (this.factura && this.factura.internalStatus && (this.factura.internalStatus == 'POSTED' || this.factura.internalStatus == 'CREATED' || this.factura.internalStatus == 'REJECTED')) {
                this.factura.accionSRI = "enviar"; //Sólo enviar-autorizar-notificar al SRI
            } else {
                this.factura.accionSRI = "emitir"; //Crear-enviar-autorizar-notificar
            }

            this.factura.enviarSRI = true;
            this.factura.ptoEmi = this.emissionPointSelected.name;
            this.factura.estab = this.establishment.name;
//            this.factura.paymentMethod = this.selectedPaymentMethod.code; //Método de pago
            this.factura.notaCredito.tipoDocumentoModificacion = this.selectedTipoComprobante.code; //Tipo de documento de modificacion
            if (this.camposAdicionales && this.camposAdicionales.length > 0) {
                this.factura.camposAdicionales = this.camposAdicionales;
            }
            if (this.destinatarios && this.destinatarios.length > 0) {
                this.factura.destinatarios = this.destinatarios;
            }

            let header = "";
            let body = "";
            let type = "";
            let subErrors:VeronicaApiSubErrorData = null;

            //Guardar la factura en persistencia para luego recargar las facturas
            this.comprobantesService.enviarNotasCredito(this.factura).subscribe(
                async (data) => {
                    const entidad = "Nota de crédito"
                    if (data['success'] && data['success'] == true &&  data['result']) {
                        let dataResult = data['result'];
                        let regresaComprobante: boolean = dataResult['comprobantes'] && Array.isArray(dataResult['comprobantes']) && dataResult['comprobantes'].length > 0;
                        const comprobantes = dataResult['comprobantes'];
                        if (regresaComprobante && dataResult['estado'] == 'APPLIED'){
                            //const mensajeSRI = comprobantes[0]['mensajes'][0]['mensaje'];
                            header = this.appConfig.ux.messages.success + ` ${entidad} Autorizada por el SRI`;
                            body = `La ${entidad} fue autorizada por SRI y se notificó al cliente.`;
                            type = "success"
                        } else if (regresaComprobante && dataResult['estado'] != 'APPLIED'){
                            const mensajeSRI = comprobantes[0]['mensajes'][0]['mensaje'];
                            header = this.appConfig.ux.messages.error + ` ${entidad} devuelta por el SRI`;
                            body = `La ${entidad} fue recibida por SRI, pero no fue autorizada. Se marcó con el estado: ${dataResult['estado']}. El SRI respondió: ${mensajeSRI}`;
                            type = "error"
                        } else if (!regresaComprobante && dataResult['estado'] == 'APPLIED'){
                            header = this.appConfig.ux.messages.success + ` ${entidad} AUTORIZADA por el SRI`;
                            body = `La ${entidad} fue autorizada por SRI y se notificó al cliente.`;
                            type = "success"
                        } else {
                            header = this.appConfig.ux.messages.warn + ` ${entidad} devuelta por el SRI`;
                            body = `La ${entidad} fue recibida por SRI, pero no fue autorizada. Se marcó con el estado: ${dataResult['estado']}.`;
                            type = "warn"
                        }
                        
                        //Mostar el resultado
                        this.resultData = { header: header, body: body, type: type, subErrors: null };
                        this.procesando = false;
                        this.resultDataButtons = [];
                        if (dataResult['estado'] == 'APPLIED'){
                            this.resultDataButtons.push(this.appConfig.ux.resultDataButtons.buttonNuevaFactura);
                            this.resultDataButtons.push(this.appConfig.ux.resultDataButtons.buttonVerListado);
                        } else {
                            this.resultDataButtons.push(this.appConfig.ux.resultDataButtons.buttonOk);
                        }
                        this.mostrarResultData = true;
                        //this.fazilService.irAInicio();
                    } else if (data['success'] && data['success'] == false && data['errors']) {
                        this.resultDataButtons = [];
                        let dataError = data['errors'];
                        if (dataError['type'] == 'error-plan') {
                            header = dataError['message'].split('.')[0];
                            body = dataError['message'] ? dataError['message'].substring(dataError['message'].indexOf('.') + 1) : environment.settings.errorMsgs.error500;
                            this.resultDataButtons.push(this.appConfig.ux.resultDataButtons.buttonStatic);
                            this.resultDataButtons.push(this.appConfig.ux.resultDataButtons.buttonSuscription);
                        } else {
                            header = this.appConfig.ux.messages.error;
                            body = dataError['message'] ? dataError['message'] : environment.settings.errorMsgs.error500_SRI;
                            this.resultDataButtons.push(this.appConfig.ux.resultDataButtons.buttonOk);
                        }
                        type = dataError['type'] ? dataError['type'] : 'error';
                        this.resultData = { header: header, body: body, type: type, subErrors: null };
                        this.procesando = false;
                        this.mostrarResultData = true;
                    } else if (data['errors']) {
                        this.resultDataButtons = [];
                        let dataError = data['errors'];
                        if (dataError['type'] == 'error-plan') {
                            header = dataError['message'].split('.')[0];
                            body = dataError['message'] ? dataError['message'].substring(dataError['message'].indexOf('.') + 1) : environment.settings.errorMsgs.error500;
                            this.resultDataButtons.push(this.appConfig.ux.resultDataButtons.buttonStatic);
                            this.resultDataButtons.push(this.appConfig.ux.resultDataButtons.buttonSuscription);
                        } else {
                            header = this.appConfig.ux.messages.error;
                            body = dataError['message'] ? dataError['message'] : environment.settings.errorMsgs.error500_SRI;
                            this.resultDataButtons.push(this.appConfig.ux.resultDataButtons.buttonOk);
                        }
                        type = dataError['type'] ? dataError['type'] : 'error';
                        this.resultData = { header: header, body: body, type: type, subErrors: null };
                        this.procesando = false;
                        this.mostrarResultData = true;
                    }
                },
                async (err) => {
                    header = this.appConfig.ux.messages.error;
                    type = this.appConfig.ux.messagesType.error;
                    if (err['errors']){
                        body = (err && err["errors"]["message"]) ? err["errors"]["message"] : environment.settings.errorMsgs.error500;
                        subErrors = err["errors"]["payload"]["errors"]["payload"]["subErrors"];
                    } else {
                        body = (err && err["message"]) ? err["message"] : environment.settings.errorMsgs.error500;
                    }
                    this.resultData = { header: header, body: body, type: type, subErrors: subErrors };
                    this.resultDataButtons = [];
                    this.resultDataButtons.push(this.appConfig.ux.resultDataButtons.buttonOk);
                    this.procesando = false;
                    this.mostrarResultData = true;
                }
            );
        }
    }

    resetVariablesSubjects(): void {
        this.ui.limpiarMessages();
        this.mostrarEditorSubject = false;
        this.subject = new Subject();
    }

    nuevoContacto() {
        this.resetVariablesSubjects();
        this.mostrarEditorSubject = true;
    }

    formSubjectCustomerCompleto() {
        return this.subjectCodeValid;
    }

    resetVariablesProducts(): void {
        this.ui.limpiarMessages();
        this.mostrarEditorProduct = false;
        this.product = new Product();
    }

    nuevoServicio() {
        this.resetVariablesProducts();
        this.productType = (this.productTypes && this.productTypes.length) ? this.productTypes[0]['value'] : null;
        this.mostrarEditorProduct = true;
    }

    formProductCompleto() {
        return true;
    }

    async guardarServicio() {
        this.ui.limpiarMessages();
        if (!this.formProductCompleto()) {
            this.ui.mostrarMensaje("error", `${this.appConfig.ux.formIvalid}`);
        } else {
            //Establecer valores UX
            if (this.iva12) {
                this.product.taxType = '2'; //TABLA 17. IVA 
                this.product.taxFactor = this.appConfig.app.iva.factor;
            } else {
                this.product.taxType = '2';  //TABLA 17. IVA con porcentaje 0
                this.product.taxFactor = 0;
            }
            this.product.productType = this.productType;
            this.product.photo = null;
            //Guardar product en persistencia
            this.serviciosService.enviarProducto(this.product).subscribe(
                async (data) => {
                    this.productSelected = data;
                    this.productSelected.amount = 1;
                    this.agregarProductoSeleccionadoDeProductos();
                    //Servicios/Productos
                    this.mostrarEditorProduct = false;
                    this.mostrarPopupProducts = false;
                    this.ui.mostrarMensaje("success", `${this.product.name} ha sido registrado con éxito.`);
                },
                (err) => {
                    this.ui.mostrarError(err);
                }
            );
        }
    }

    /**
    ** Métodos de formulario
    **/
    resetSumadoresAll() {
        this.factura.subTotal = 0.00;
        this.resetSumadores();
    }

    resetSumadores() {
        //Encerar sumadores
        this.factura.descuento = 0.00;
        this.factura.propina = 0.00;
        this.factura.subTotalIva0 = 0.00;
        this.factura.subTotalIva12 = 0.00;
        this.factura.iva12Total = 0.00;
        this.factura.iva0Total = 0.00;
        this.factura.importeTotal = 0.00;
    }

    agregarProductoSeleccionado(p: Product) {
        let detail: InvoiceDetail = new InvoiceDetail();
        detail.product = p;
        detail.amount = detail.product.amount;
        detail.price = detail.product.price;
        this.details = this.ui.addDetailToInvoice(this.details, detail, false);
    }

    generarFacturaSimpleComplex() {
        if (this.details && this.details.length > 0) {
            if (this.isUnitDetail) {
                this.generarFacturaSimple(this.details[0]);
            } else {
                this.generarFacturaComplex();
            }
        }
        this.resetSumadoresAll();
        this.calcularTotalesFactura();//En función de sus detalles
    }

    generarFacturaSimple(detail: InvoiceDetail) {
        this.product = detail.product; //Cargar el producto único
        this.exitenProductosSeleccionados = this.product != null;
    }

    generarFacturaComplex() {
        this.exitenProductosSeleccionados = false;
        if (this.details && this.details.length) {
            this.exitenProductosSeleccionados = true;
        }
    }

    calcularTotalesFactura() {
        
        if (!this.cambiarPorcentajesIVA) {
        
            if (this.details && this.details.length) {
                let hayErrorTipoImpuesto = false;
                let errores = '';
                this.details.forEach(detail => {
                    let subtotal = (detail.amount * detail.price) -  detail.discount;
                    hayErrorTipoImpuesto = detail.product.taxType != this.appConfig.app.iva.id;
                    if ( hayErrorTipoImpuesto ){
                        errores = errores + (errores == '' ? '' : ', ') + detail.productName;
                    }
                    if ( detail.product.taxType == this.appConfig.app.iva.id && detail.product.taxFactor == this.appConfig.app.iva.factor ) {
                        this.factura.subTotalIva12 = this.factura.subTotalIva12 + precisionRound(subtotal, 2);
                        this.factura.iva12Total = this.factura.iva12Total + precisionRound(subtotal * (detail.product.taxFactor / 100), 2);
                    } else if (detail.product.taxType == this.appConfig.app.iva.id && detail.product.taxFactor == 0.0) {
                        this.factura.subTotalIva0 = this.factura.subTotalIva0 + precisionRound(subtotal, 2);
                    }
                });
                this.factura.subTotal = this.factura.subTotalIva12 + this.factura.subTotalIva0;
                this.factura.importeTotal = precisionRound(this.factura.subTotal + this.factura.iva12Total, 2);

                if (hayErrorTipoImpuesto){
                    this.ui.mostrarMensaje("error", `La configuración del tipo de impuesto de los productos: ${errores}, no es valida. Corrija e intente nuevamente.`);
                }
            }
        } else {
            
            if (this.details && this.details.length) {
                let hayErrorTipoImpuesto = false;
                let errores = '';
                this.details.forEach(detail => {
                    let subtotal = (detail.amount * detail.price) -  detail.discount;
                    hayErrorTipoImpuesto = detail.product.taxType != this.appConfig.app.iva.id;
                    if ( hayErrorTipoImpuesto ){
                        errores = errores + (errores == '' ? '' : ', ') + detail.productName;
                    }
                    if ( detail.product.taxType == this.appConfig.app.iva.id && detail.product.taxFactor > 0) {
                        this.factura.subTotalIva12 = this.factura.subTotalIva12 + precisionRound(subtotal, 2);
                        this.factura.iva12Total = this.factura.iva12Total + precisionRound(subtotal * (this.iva.factor / 100), 2);
                        detail.taxFactor = this.iva.factor; //REEMPLAZA EL FACTOR DE IMPUESTO
                        detail.taxType = detail.product.taxType; //REEMPLAZA EL TIPO DE IMPUESTO
                    } else if (detail.product.taxType == this.appConfig.app.iva.id && this.product.taxFactor== 0.0) {
                        this.factura.subTotalIva0 = this.factura.subTotalIva0 + precisionRound(subtotal, 2);
                        detail.taxFactor = this.product.taxFactor; //REEMPLAZA EL FACTOR DE IMPUESTO
                        detail.taxType = detail.product.taxType; //REEMPLAZA EL TIPO DE IMPUESTO
                    }
                });
                this.factura.subTotal = this.factura.subTotalIva12 + this.factura.subTotalIva0;
                this.factura.importeTotal = precisionRound(this.factura.subTotal + this.factura.iva12Total, 2);

                if (hayErrorTipoImpuesto){
                    this.ui.mostrarMensaje("error", `La configuración del tipo de impuesto de los productos: ${errores}, no es valida. Corrija e intente nuevamente.`);
                }
            }
        }
    }

    activePopupSubjectCustomers(event) {
        this.subjectCustomersFiltered = [...this.subjectCustomers];
        this.mostrarPopupSubjectCustomers = true;
    }

    async filteredSubjectCustomerByKeyword(event) {
        this.processFilter = true;
        this.subjectCode = "";
        if (event && event.target && event.target.value && event.target.value.length > 3) {
            this.subjectCode = event.target.value.toLocaleLowerCase();
            this.pageOptions = { page: 0, pageSize: 999, filter: this.subjectCode, orderBy: 'name', order: 'ASC' };
            const page = await this.contactosService.getContactosPorUsuarioConectadoData(this.pageOptions);
            this.subjectCustomersFiltered = page['content'];
        }
    }

    async searchSubjectPorCode(event) {
        this.ui.limpiarMessages();
        this.subjectCodeValid = false;
        let code: string = this.subjectCode ? this.subjectCode.toString() : "";

        if (!code || code.length == 0) {
            return;
        }

        let isRUC: boolean = false;
        let isCI: boolean = false;

        if (code && code.length == 10) {
            isCI = validateDni(code);
        } else if (code && code.length == 13) {
            isRUC = validateRUC(code);
        }

        if (isCI || isRUC) {

            this.subjectCodeValid = true;

            let msg = "Verificando " + (isCI ? 'CI' : isRUC ? 'RUC' : '') + " Nº. " + code;
            this.verificandoData = this.ui.buildResultFromVerify(msg, this.appConfig.ux.messagesType.success);
            this.verificando = true;

            //Buscar si existe un usuario con ese code
            let data = await this.contactosService.getContactoPorCodeYUsuarioConectadoData(code);
            if (data && data['uuid']) {
                this.subject = data;
                this.ui.mostrarMensaje("info", `¡Está casi listo tu contacto ${this.subject.initials} para ${this.appConfig.app.name}!.`);
                this.verificando = false;
            } else {
                this.subject = new Subject();
                this.subject.code = this.subjectCode;
                this.verificando = false;
            }
        } else {
            this.subject = new Subject();
            this.verificando = false;
            this.ui.mostrarMensaje("error", `${this.appConfig.validationMsgs.cirucCustomerInvalid}`);
        }
    }


    async searchEmailByCode(event) {
        this.ui.limpiarMessages();
        this.emailValid = false;
        let code: string = this.subject.email ? this.subject.email : "";

        if (!code || code.length == 0) {
            return;
        }

        let msg = "Verificando email " + code;
        this.verificandoData = this.ui.buildResultFromVerify(msg, this.appConfig.ux.messagesType.success);
        this.verificando = true;

        if (code) {
            let emailExistente = false;

            this.emailValid = validateEmail(code);

            if (this.emailValid) {
                emailExistente = await this.administracionService.getEmailPorCodeData(code);
                this.verificando = false;
            } else {
                this.verificando = false;
                this.ui.mostrarMensaje("error", this.appConfig.validationMsgs.emailPattern);
                return;
            }
            if (emailExistente) {
                this.ui.mostrarMensaje("warn", `El correo electrónico ya se encuentra registrado.`);
            }
        } else {
            this.verificando = false;
        }
    }

    cargarDataSubjectCustomer(event, item: SubjectCustomer) {
        this.ui.limpiarMessages();
        if (item) {
            this.subjectCustomer = item;
            this.factura.direccion = this.subjectCustomer.customerDireccion;
            this.destinatarios.push(this.subjectCustomer.customerEmail);
            this.filteredDestinatarios();
            this.mostrarPopupSubjectCustomers = false;
        }
    }

    activePopupProducts(event) {
        if (!this.seRealizoBusquedaEspecifica){
            //Cargar servicios/productos
            this.busquedaInicial();
        }
        this.mostrarPopupProducts = true;
    }

    async filteredProductByKeyword(event) {
        
        this.processFilter = true;
        this.pageOptions = { page: 0, pageSize: 999, filter: event.target.value, orderBy: 'name', order:'ASC' };
        const data = await this.serviciosService.getProductosPorOrganizacionDeUsuarioConectadoData(this.pageOptions);
        const products = this.ui.updateProductsByDetails(this.details, data['content']);
        this.productsFiltered = [...products];
        this.processFilter = false;
        this.seRealizoBusquedaEspecifica = true;
    }
    
    async busquedaInicial() {
        
        this.processFilter = true;
        this.pageOptions = { page: 0, pageSize: 999, filter: '', orderBy: 'name', order:'ASC' };
        const data = await this.serviciosService.getProductosPorOrganizacionDeUsuarioConectadoData(this.pageOptions);
        const products = this.ui.updateProductsByDetails(this.details, data['content']);
        this.productsFiltered = [...products];
        this.processFilter = false;
    }

    cargarDataProduct(event, item: Product) {
        this.ui.limpiarMessages();
        if (event) {
            this.productSelected = item;
            if (!item.amount || item.amount == 0) {
                this.productSelected.amount = 1;
            }
            this.agregarProductoSeleccionadoDeProductos();
            this.mostrarPopupProducts = false;
        }
    }

    agregarProductoSeleccionadoDeProductos() {
        this.agregarProductoSeleccionado(this.productSelected);
        this.products = this.ui.updateProductsByDetails(this.details, this.products);
        this.isUnitDetail = this.ui.checkInvoiceSimpleComplex(this.details);
        this.generarFacturaSimpleComplex();
        this.productSelected = new Product();
    }

    quitarProductoSeleccionadoDeProductos(event, item: Product) {
        this.productSelected = item;
        this.productSelected.amount = 0;
        this.agregarProductoSeleccionadoDeProductos();
        this.mostrarPopupProducts = false;
    }

    calcularConSubtotalPersonalizado(event) {
        let price = this.factura.subTotal;
        if (this.product && this.product.id) {//Buscar producto al cual se ha cambiado el precio para cambiar su precio
            let detail: InvoiceDetail = new InvoiceDetail();
            detail.product = this.product;
            detail.price = Number(price);
            detail.amount = 1;
            this.ui.addDetailToInvoice(this.details, detail, false);
        }
        this.resetSumadores();
        this.calcularTotalesFactura();
    }

    ejecutarAccionResult(event, accion: string, item: any) {
        this.ui.limpiarMessages();
        if (accion == this.appConfig.ux.actionsExecute.close) {
            this.mostrarResultData = false;
        } else if (accion == 'nueva') {
            this.mostrarResultData = false;
            this.fazilService.irANotaDeCredito();
        } else if (accion == 'listado') {
            this.mostrarResultData = false;
            this.fazilService.irAInicioNotasdeCredito();
        } else {
            this.ui.ejecutarAccionResultFromData(event, accion);//Acciones generales
        }
    }

    camposAdicionalesValidos(): boolean {
        let isValid: boolean = true;
        return isValid;
    }

    filteredDestinatarios() {
        this.filtered = this.destinatarioCtrl.valueChanges.pipe(
            startWith(null),
            map((destinatario: string | null) => (destinatario ? this._filterDestinatario(destinatario) : this.destinatariosAll.slice())),
        );
    }

    private _filterDestinatario(value: string): string[] {
        const filterValue = value.toLowerCase();
        //return this.destinatariosAll.filter(val => val.toLowerCase().includes(filterValue));
        return this.destinatariosAll.filter(val => val.toLowerCase().indexOf(filterValue) === 0);
    }

    agregarDestinatario(event: MatChipInputEvent): void {

        const input = event.input;
        const value = (event.value || '').trim();

        // Añadir nuestro destinatario
        if (value) {
            const isOptionSelected = this.matAutocomplete.options.some(option => option.selected);
            if (!isOptionSelected && validateEmail(value.trim())) {//Validar si es email
                this.destinatarios.push(value.trim());
            }
        }

        // Limpiar el input
        if (input) {
            input.value = '';
        }

        this.destinatarioCtrl.setValue(null);
    }

    agregarDestinatarioBlur(event: FocusEvent): void {
        const target: HTMLElement = event.relatedTarget as HTMLElement;
        if (!target || target.tagName !== 'MAT-OPTION') {
            const matChipEvent: MatChipInputEvent = { input: this.destinatarioInput.nativeElement, value: this.destinatarioInput.nativeElement.value };
            this.agregarDestinatario(matChipEvent);
        }
    }

    removerDestinatario(value: string): void {
        const index = this.destinatarios.indexOf(value);
        if (index >= 0) {
            this.destinatarios.splice(index, 1);
        }
    }

    selectedDestinatario(event: MatAutocompleteSelectedEvent): void {
        event.option.deselect();
        this.destinatarios.push(event.option.viewValue);
        this.destinatarioInput.nativeElement.value = '';
        this.destinatarioCtrl.setValue(null);
    }

    filtrarNotaCreditoTipoDocumento(event) {
        this.filtrados = this.ui.filteredAutocomplete(this.tiposComprobantes, 'description', event.query);
    }
    
    
    actualizarImpuestosEnDetalles(evt:any){
        const ivas_candidatos = this.appConfig.app.ivas.filter(x => this.factura.notaCredito.fechaEmisionDocumentoModificado >= x.desde && this.factura.notaCredito.fechaEmisionDocumentoModificado <= x.hasta);
        //TODO elegir el más idoneo en base a otro criterio
        this.iva = ivas_candidatos[0]; //Decidir como elegir el iva a aplicar
        this.cambiarPorcentajesIVA = true;
        this.resetSumadoresAll();
        this.calcularTotalesFactura();
    }
    
    handleSubjectCustomerSaved(subjectCustomerOutput:SubjectCustomerOutput){
        
        if (subjectCustomerOutput.success){
            const esCedula:boolean = subjectCustomerOutput.data.customerCode.length == 10;
            this.cargarDataSubjectCustomer(null, subjectCustomerOutput.data);
//            this.cargarDataSubjectCustomer(null, subjectCustomerOutput.data, esCedula);
            this.mostrarPopupSubjectCustomers = false;
            this.mostrarEditorSubject = false;
        }   
    }

}
